import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { GlobalSpinnerService } from '@shared/services/global-spinner.service';
import { NavBarService } from '@home/shared/modules/nav-bar/nav-bar.service';
import { AsyncPipe } from '@angular/common';
import { SpinnerModule } from '@shared/components/spinner/spinner.module';

@Component({
  selector: 'zef-global-spinner',
  templateUrl: './global-spinner.component.html',
  styleUrls: ['./global-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, SpinnerModule],
})
export class GlobalSpinner {
  readonly gs = inject(GlobalSpinnerService);
  readonly ns = inject(NavBarService);
}
